module.exports = __webpack_public_path__ + "img/pd-img-face8.2a849e7a.png";